module.exports = __webpack_public_path__ + "static/img/mofa-csp.2d90e5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/mofa-csp.jpg
// module id = 0B5z
// module chunks = 0